// extracted by mini-css-extract-plugin
export default {"wrapper":"Q1-z","play":"R1-z"};